import Dexie, { Table } from 'dexie';
import { FormData } from './types';

export interface SavedForm {
    formType: string;
    data: FormData;
    updatedAt: number;
    /**
     * The exact query string (e.g. "?foo=bar") the draft corresponds to.
     * Used to avoid loading a draft over values provided via a different shared-link URL.
     */
    queryString?: string;
}

export class VehicleDatabase extends Dexie {
    formData!: Table<SavedForm, string>;

    constructor() {
        super('BK Mobility');
        this.version(1).stores({
            formData: 'formType, updatedAt'
        });
        this.version(2).stores({
            formData: 'formType, updatedAt, queryString'
        });
    }
}

export const db = new VehicleDatabase();
